// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProfessionalInfo_prof-info__y\\+t2- {
  display: grid;
  gap: 20px;
  width: 100%;
}
.ProfessionalInfo_prof-info__card__qwCN- {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.ProfessionalInfo_prof-info__card__qwCN-:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);
}
.ProfessionalInfo_prof-info__card--profile__0SKlx, .ProfessionalInfo_prof-info__card--section__2bF16 {
  padding: 28px 30px;
}
@media (max-width: 768px) {
  .ProfessionalInfo_prof-info__card--profile__0SKlx, .ProfessionalInfo_prof-info__card--section__2bF16 {
    padding: 24px;
  }
}
.ProfessionalInfo_prof-info__card--media__TWi2u {
  padding: 0;
}
.ProfessionalInfo_prof-info__card--tabs__4VBP9 {
  padding: 0;
}
.ProfessionalInfo_prof-info__hero-wrapper__kto8D {
  position: relative;
  aspect-ratio: 12/5;
  width: 100%;
}
.ProfessionalInfo_prof-info__hero-wrapper__kto8D .image-professional-wrapper {
  height: 100%;
  border-radius: 0;
}
.ProfessionalInfo_prof-info__profile-head__yWdqW {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: start;
}
.ProfessionalInfo_prof-info__name__yCiZs {
  margin: 0;
  font-size: 44px;
  letter-spacing: -0.04em;
  font-weight: 800;
  color: #13231D;
  line-height: 1.05 !important;
}
@media (max-width: 768px) {
  .ProfessionalInfo_prof-info__name__yCiZs {
    font-size: 32px;
  }
}
.ProfessionalInfo_prof-info__role__kwGhN {
  margin: 10px 0 0;
  font-size: 21px;
  font-weight: 800;
  color: rgba(19, 35, 29, 0.68);
}
@media (max-width: 768px) {
  .ProfessionalInfo_prof-info__role__kwGhN {
    font-size: 18px;
  }
}
.ProfessionalInfo_prof-info__share__U\\+S23 {
  font-size: 12px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  cursor: pointer;
}
.ProfessionalInfo_prof-info__share__U\\+S23:hover {
  color: #13231D;
}
.ProfessionalInfo_prof-info__specialties-row__rehAK {
  margin-top: 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.ProfessionalInfo_prof-info__specialties-label__tUByp {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: rgba(19, 35, 29, 0.68);
  white-space: nowrap;
}
.ProfessionalInfo_prof-info__icon-tag__YNQjI {
  width: 20px;
  height: 20px;
  object-fit: contain;
  opacity: 0.72;
}
.ProfessionalInfo_prof-info__chip-row__4S9Mz {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.ProfessionalInfo_prof-info__tag__Syrqq {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 11px;
  border-radius: 999px;
  background: #F8F6F2;
  font-size: 11px;
  font-weight: 800;
}
.ProfessionalInfo_prof-info__tag--cuerpo__HCj9G {
  background: rgba(36, 46, 123, 0.1);
  color: #242E7B;
  border: 1px solid #242E7B;
}
.ProfessionalInfo_prof-info__tag--conciencia__l08vO {
  background: rgba(87, 64, 147, 0.1);
  color: #574093;
  border: 1px solid #574093;
}
.ProfessionalInfo_prof-info__tag--mente__\\+NSCr {
  background: rgba(93, 138, 186, 0.12);
  color: #4F769F;
  border: 1px solid #4F769F;
}
.ProfessionalInfo_prof-info__tag--energia__ZMJl5 {
  background: rgba(83, 169, 110, 0.12);
  color: #3F8355;
  border: 1px solid #3F8355;
}
.ProfessionalInfo_prof-info__meta-line__tRVCw {
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 700;
}
.ProfessionalInfo_prof-info__icon-check__vXSnb {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  flex: 0 0 auto;
}
.ProfessionalInfo_prof-info__icon-check__vXSnb:before {
  content: "";
  position: absolute;
  left: 1px;
  top: 3px;
  width: 8px;
  height: 11px;
  border-right: 3px solid #39a84b;
  border-bottom: 3px solid #39a84b;
  transform: rotate(40deg);
  margin-top: -4px;
}
.ProfessionalInfo_prof-info__section-title__wcvUG {
  margin: 0 0 12px;
  font-size: 32px;
  font-weight: 800;
  color: #13231D;
  letter-spacing: -0.03em !important;
  line-height: 1.08 !important;
}
.ProfessionalInfo_prof-info__copy__V2IyZ {
  color: rgba(19, 35, 29, 0.68);
  line-height: 1.75;
  font-size: 15px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
.ProfessionalInfo_prof-info__copy__V2IyZ p + p {
  margin-top: 14px;
}
.ProfessionalInfo_prof-info__read-more__7iYw2 {
  background: none;
  border: none;
  color: #82B194;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  margin-top: 8px;
  font-size: 14px;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/ProfessionalDetail/ProfessionalInfo.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAHA;EACI,aAAA;EACA,SAAA;EACA,WAAA;AAMJ;AAJI;EACI,mBAAA;EACA,wCAAA;EACA,mBD6BQ;EC5BR,2CD4CM;EC3CN,gBAAA;EACA,qDAAA;AAMR;AAJQ;EACI,2BAAA;EACA,8CAAA;AAMZ;AAHQ;EAEI,kBAAA;AAIZ;AAFY;EAJJ;IAKQ,aAAA;EAKd;AACF;AAFQ;EACI,UAAA;AAIZ;AADQ;EACI,UAAA;AAGZ;AACI;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;AACR;AACQ;EACI,YAAA;EACA,gBAAA;AACZ;AAGI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AADR;AAII;EACI,SAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,cDhDe;ECiDf,4BAAA;AAFR;AAIQ;EARJ;IASQ,eAAA;EADV;AACF;AAII;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BD1De;ACwDvB;AAIQ;EANJ;IAOQ,eAAA;EADV;AACF;AAII;EACI,eAAA;EACA,6BAvFG;EAwFH,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAFR;AAIQ;EACI,cD9EW;AC4EvB;AAMI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAJR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BD9Fe;EC+Ff,mBAAA;AALR;AAQI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AANR;AASI;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAPR;AAUI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBD5He;EC6Hf,eAAA;EACA,gBAAA;AARR;AAUQ;EACI,kCAAA;EACA,cAAA;EACA,yBAAA;AARZ;AAWQ;EACI,kCAAA;EACA,cAAA;EACA,yBAAA;AATZ;AAYQ;EACI,oCAAA;EACA,cAAA;EACA,yBAAA;AAVZ;AAaQ;EACI,oCAAA;EACA,cAAA;EACA,yBAAA;AAXZ;AAeI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,6BDzJe;EC0Jf,gBAAA;AAbR;AAgBI;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAdR;AAgBQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;EACA,gCAAA;EACA,wBAAA;EACA,gBAAA;AAdZ;AAkBI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDxLe;ECyLf,kCAAA;EACA,4BAAA;AAhBR;AAmBI;EACI,6BD5Le;EC6Lf,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAjBR;AAkBQ;EACI,gBAAA;AAhBZ;AAoBI;EACI,gBAAA;EACA,YAAA;EACA,cDzNe;EC0Nf,gBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;AAlBR","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-bg: $color-bg;\n$bw-surface: $color-surface;\n$bw-surface-2: $color-surface-soft;\n$bw-text: $text-main;\n$bw-muted: rgba($text-main, 0.68);\n$bw-border: $color-border;\n$bw-primary: $color-primary;\n$bw-radius-lg: $radius-xl;\n$bw-muted-solid: $text-secondary;\n$bw-shadow: $shadow-card;\n\n.prof-info {\n    display: grid;\n    gap: 20px;\n    width: 100%;\n\n    &__card {\n        background: $bw-surface;\n        border: 1px solid $bw-border;\n        border-radius: $bw-radius-lg;\n        box-shadow: $bw-shadow;\n        overflow: hidden;\n        transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n        &:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);\n        }\n\n        &--profile,\n        &--section {\n            padding: 28px 30px;\n\n            @media (max-width: 768px) {\n                padding: 24px;\n            }\n        }\n\n        &--media {\n            padding: 0;\n        }\n\n        &--tabs {\n            padding: 0;\n        }\n    }\n\n    &__hero-wrapper {\n        position: relative;\n        aspect-ratio: 12 / 5;\n        width: 100%;\n\n        :global(.image-professional-wrapper) {\n            height: 100%;\n            border-radius: 0;\n        }\n    }\n\n    &__profile-head {\n        display: flex;\n        justify-content: space-between;\n        gap: 16px;\n        align-items: start;\n    }\n\n    &__name {\n        margin: 0;\n        font-size: 44px;\n        letter-spacing: -0.04em;\n        font-weight: 800;\n        color: $bw-text;\n        line-height: 1.05 !important;\n\n        @media (max-width: 768px) {\n            font-size: 32px;\n        }\n    }\n\n    &__role {\n        margin: 10px 0 0;\n        font-size: 21px;\n        font-weight: 800;\n        color: $bw-muted-solid;\n\n        @media (max-width: 768px) {\n            font-size: 18px;\n        }\n    }\n\n    &__share {\n        font-size: 12px;\n        color: $bw-muted;\n        font-weight: 700;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        white-space: nowrap;\n        cursor: pointer;\n\n        &:hover {\n            color: $bw-text;\n        }\n    }\n\n    &__specialties-row {\n        margin-top: 18px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        flex-wrap: wrap;\n    }\n\n    &__specialties-label {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        font-size: 14px;\n        font-weight: 700;\n        color: $bw-muted-solid;\n        white-space: nowrap;\n    }\n\n    &__icon-tag {\n        width: 20px;\n        height: 20px;\n        object-fit: contain;\n        opacity: 0.72;\n    }\n\n    &__chip-row {\n        display: flex;\n        gap: 8px;\n        flex-wrap: wrap;\n    }\n\n    &__tag {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        min-height: 30px;\n        padding: 0 11px;\n        border-radius: 999px;\n        background: $bw-surface-2;\n        font-size: 11px;\n        font-weight: 800;\n\n        &--cuerpo {\n            background: rgba(36, 46, 123, 0.10);\n            color: #242E7B;\n            border: 1px solid #242E7B;\n        }\n\n        &--conciencia {\n            background: rgba(87, 64, 147, 0.10);\n            color: #574093;\n            border: 1px solid #574093;\n        }\n\n        &--mente {\n            background: rgba(93, 138, 186, 0.12);\n            color: #4F769F;\n            border: 1px solid #4F769F;\n        }\n\n        &--energia {\n            background: rgba(83, 169, 110, 0.12);\n            color: #3F8355;\n            border: 1px solid #3F8355;\n        }\n    }\n\n    &__meta-line {\n        margin-top: 14px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 14px;\n        color: $bw-muted-solid;\n        font-weight: 700;\n    }\n\n    &__icon-check {\n        width: 14px;\n        height: 14px;\n        display: inline-block;\n        position: relative;\n        flex: 0 0 auto;\n\n        &:before {\n            content: \"\";\n            position: absolute;\n            left: 1px;\n            top: 3px;\n            width: 8px;\n            height: 11px;\n            border-right: 3px solid #39a84b;\n            border-bottom: 3px solid #39a84b;\n            transform: rotate(40deg);\n            margin-top: -4px;\n        }\n    }\n\n    &__section-title {\n        margin: 0 0 12px;\n        font-size: 32px;\n        font-weight: 800;\n        color: $bw-text;\n        letter-spacing: -.03em !important;\n        line-height: 1.08 !important;\n    }\n\n    &__copy {\n        color: $bw-muted-solid;\n        line-height: 1.75;\n        font-size: 15px;\n        overflow-wrap: break-word;\n        word-wrap: break-word;\n        word-break: break-word;\n        p+p {\n            margin-top: 14px;\n        }\n    }\n\n    &__read-more {\n        background: none;\n        border: none;\n        color: $bw-primary;\n        font-weight: 700;\n        cursor: pointer;\n        padding: 0;\n        margin-top: 8px;\n        font-size: 14px;\n        text-decoration: underline;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prof-info": `ProfessionalInfo_prof-info__y+t2-`,
	"prof-info__card": `ProfessionalInfo_prof-info__card__qwCN-`,
	"prof-info__card--profile": `ProfessionalInfo_prof-info__card--profile__0SKlx`,
	"prof-info__card--section": `ProfessionalInfo_prof-info__card--section__2bF16`,
	"prof-info__card--media": `ProfessionalInfo_prof-info__card--media__TWi2u`,
	"prof-info__card--tabs": `ProfessionalInfo_prof-info__card--tabs__4VBP9`,
	"prof-info__hero-wrapper": `ProfessionalInfo_prof-info__hero-wrapper__kto8D`,
	"prof-info__profile-head": `ProfessionalInfo_prof-info__profile-head__yWdqW`,
	"prof-info__name": `ProfessionalInfo_prof-info__name__yCiZs`,
	"prof-info__role": `ProfessionalInfo_prof-info__role__kwGhN`,
	"prof-info__share": `ProfessionalInfo_prof-info__share__U+S23`,
	"prof-info__specialties-row": `ProfessionalInfo_prof-info__specialties-row__rehAK`,
	"prof-info__specialties-label": `ProfessionalInfo_prof-info__specialties-label__tUByp`,
	"prof-info__icon-tag": `ProfessionalInfo_prof-info__icon-tag__YNQjI`,
	"prof-info__chip-row": `ProfessionalInfo_prof-info__chip-row__4S9Mz`,
	"prof-info__tag": `ProfessionalInfo_prof-info__tag__Syrqq`,
	"prof-info__tag--cuerpo": `ProfessionalInfo_prof-info__tag--cuerpo__HCj9G`,
	"prof-info__tag--conciencia": `ProfessionalInfo_prof-info__tag--conciencia__l08vO`,
	"prof-info__tag--mente": `ProfessionalInfo_prof-info__tag--mente__+NSCr`,
	"prof-info__tag--energia": `ProfessionalInfo_prof-info__tag--energia__ZMJl5`,
	"prof-info__meta-line": `ProfessionalInfo_prof-info__meta-line__tRVCw`,
	"prof-info__icon-check": `ProfessionalInfo_prof-info__icon-check__vXSnb`,
	"prof-info__section-title": `ProfessionalInfo_prof-info__section-title__wcvUG`,
	"prof-info__copy": `ProfessionalInfo_prof-info__copy__V2IyZ`,
	"prof-info__read-more": `ProfessionalInfo_prof-info__read-more__7iYw2`
};
export default ___CSS_LOADER_EXPORT___;
